import { TYPES } from '../actions';

const initialState = {
  qtyChanges: [],
  currentQtyChange: null,
  totalCount: 0,
  loading: false,
  error: null
};

export const sesProductQtyChangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_SES_PRODUCT_QTY_CHANGES_SUCCESS:
      return {
        ...state,
        qtyChanges: action.payload.data.result,
        totalCount: action.payload.data.totalCount || state.totalCount,
        loading: false,
        error: null
      };

    case TYPES.ACTION_SET_SES_PRODUCT_QTY_CHANGES_SUCCESS:
      return {
        ...state,
        qtyChanges: action.payload.data.result,
        totalCount: action.payload.data.totalCount || state.totalCount,
        loading: false,
        error: null
      };

    case TYPES.ACTION_ADD_SES_PRODUCT_QTY_CHANGES_SUCCESS:
      return {
        ...state,
        qtyChanges: [...state.qtyChanges, ...action.payload.data],
        loading: false,
        error: null
      };

    case TYPES.ACTION_GET_SES_PRODUCT_QTY_CHANGES_FAIL:
    case TYPES.ACTION_SET_SES_PRODUCT_QTY_CHANGES_FAIL:
    case TYPES.ACTION_ADD_SES_PRODUCT_QTY_CHANGES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}; 